module.exports = __webpack_public_path__ + "media/bootstrap-icons/megaphone-fill-f2f29c57.svg";